import pegasus from "./01-pegasus";

document.addEventListener('DOMContentLoaded', function() {
    pegasus.decodeAllCloudflareEmails();// Init cloudflare email decoder (Cloudflare obfuscates emails for protection)

    pegasus.onResizeFinished(() => {
        pegasus.initFooterLinkColumns()
    }, true);
});
